import React, { useState, useEffect } from "react";
import {
    BrowserRouter as Router,
    Route,
    Routes,
    Navigate,
} from "react-router-dom";
import Login from "./pages/Admin/Login";
import AdminHome from "./pages/Admin/Home";
import Landscape from "./pages/Admin/DisplayOption/Landscape";
import Potrait from "./pages/Admin/DisplayOption/Potrait";
import Carousel_Portrait from "./pages/Admin/DisplayOption/Carousel_Portrait";
import Carousel_landscape from "./pages/Admin/DisplayOption/Carousel_landscape";
import Carousel from "./pages/Admin/DisplayOption/Carousel";
import Staff from "./pages/Admin/Staff/index";
import Display from "./pages/Admin/QueueNr/Display";
import DisplayAd from "./pages/Admin/QueueNr/DisplayAd";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import VerifyAdmin from "./pages/Admin/VerifyAdmin";
import CustomerView from "./pages/Admin/CustomerView/index";
import CustomerChoicePage from "./pages/Admin/CustomerView/CustomerChoicePage";
import QRCodeDisplayPage from "./pages/Admin/CustomerView/QRCodeDisplayPage";
import SmsSelectionPage from "./pages/Admin/CustomerView/SmsSelectionPage";
import NextCustomerView from "./pages/Admin/CustomerView/NextCustomerView";
import ThankYou from "./pages/Admin/CustomerView/ThankYou";
import AdManagement from "./pages/Admin/AdManagement";
import Profile from "./pages/Admin/Profile";
import Welcome from "./pages/Admin/Welcome";
import User from "./pages/User/index";
import Thankyou from "./pages/User/Thankyou";
import UserHome from "./pages/User/UserHome";
import GetQueue from "./pages/User/getqueue";
import GetTicket from "./pages/User/getticket";
import FreeTrialSignup from "./pages/User/FreeTrialSignup";
import FreeTrialVerify from "./pages/User/FreeTrialVerify";
import { useIframeCheck } from "./utils/iframeCheck";
function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(null);

    // Check iframe embedding permissions
    useIframeCheck();

    useEffect(() => {
        setIsAuthenticated(!!localStorage.getItem("token"));
    }, []);

    // Specific routes MUST come before /home/* so they match first (e.g. /home/service-management for onboarding tour)
    const protectedRoutes = [
        { path: "/home/display", element: <Display /> },
        { path: "/home/display_ad", element: <DisplayAd /> },
        { path: "/home/customer-choice", element: <CustomerChoicePage /> },
        { path: "/home/qr-display", element: <QRCodeDisplayPage /> },
        { path: "/home/customer-view", element: <CustomerView /> },
        { path: "/home/sms-customer-view", element: <SmsSelectionPage /> },
        { path: "/home/Next_customer-view", element: <NextCustomerView /> },
        { path: "/home/thank-you", element: <ThankYou /> },
        { path: "/home/staff", element: <Staff /> },
        { path: "/home/ad-management", element: <AdManagement /> },
        { path: "/home/welcome", element: <Welcome /> },
        { path: "/home/user-token", element: <User /> },
        { path: "/home/user_home", element: <UserHome /> },
        { path: "/home/thankyou", element: <Thankyou /> },
        { path: "/get-queue", element: <GetQueue /> },
        { path: "/get-ticket/:code", element: <GetTicket /> },
        { path: "/home/*", element: <AdminHome /> }, // Catch-all last so specific routes match first
    ];

    return (
        <Router>
            <Routes>
                {/* Public routes */}
                <Route path="/" element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="/verify-admin" element={<VerifyAdmin />} />
                <Route path="/free-trial" element={<FreeTrialSignup />} />
                <Route path="/free-trial-verify" element={<FreeTrialVerify />} />

                {/* Public customer-facing routes */}
                <Route
                    path="/home/customer-choice"
                    element={<CustomerChoicePage />}
                />
                <Route
                    path="/home/qr-display"
                    element={<QRCodeDisplayPage />}
                />
                <Route path="/home/customer-view" element={<CustomerView />} />
                <Route
                    path="/home/sms-customer-view"
                    element={<SmsSelectionPage />}
                />
                <Route
                    path="/home/Next_customer-view"
                    element={<NextCustomerView />}
                />
                <Route path="/home/thank-you" element={<ThankYou />} />
                <Route path="/get-queue" element={<GetQueue />} />
                <Route path="/getticket/:code" element={<GetTicket />} />
                <Route path="/get-ticket/:code" element={<GetTicket />} />

                {/* Public display routes for external sites - MUST be before protected routes */}
                <Route
                    path="/home/display_ad_Landscape"
                    element={<Landscape />}
                />
                <Route path="/home/display_ad_potrait" element={<Potrait />} />
                <Route
                    path="/home/display_ad_potrait"
                    element={<Carousel />}
                />
                <Route
                    path="/home/display_ad_Carousel_landscape"
                    element={<Carousel_landscape />}
                />
                <Route
                    path="/home/display_ad_Carousel_Portrait"
                    element={<Carousel_Portrait />}
                />
                <Route
                    path="/home/display_ad_Carousel_Portrait/*"
                    element={<Carousel_Portrait />}
                />

                {/* Old PHP links - direct React routes for backward compatibility */}
                <Route
                    path="/display_ad_landscape.php"
                    element={<Landscape />}
                />
                <Route
                    path="/display_ad_potrait.php"
                    element={<Potrait />}
                />
                <Route
                    path="/carousel_portrait.php"
                    element={<Carousel_Portrait />}
                />
                <Route
                    path="/carousel_landscape.php"
                    element={<Carousel_landscape />}
                />

                {/* Protected admin routes */}
                {protectedRoutes
                    .filter(
                        (r) =>
                            ![
                                "/home/customer-choice",
                                "/home/qr-display",
                                "/home/customer-view",
                                "/home/sms-customer-view",
                                "/home/Next_customer-view",
                                "/home/thank-you",
                                "/home/display_ad_Landscape",
                                "/home/display_ad_potrait",
                                "/home/display_ad_Carousel_landscape",
                                "/home/display_ad_Carousel_Portrait",
                                "/get-queue",
                                "/get-ticket/:code",
                            ].includes(r.path) &&
                            !r.path.startsWith("/home/display_ad_")
                    )
                    .map(({ path, element }, index) => (
                        <Route
                            key={index}
                            path={path}
                            element={
                                <ProtectedRoute
                                    isAuthenticated={isAuthenticated}
                                >
                                    {element}
                                </ProtectedRoute>
                            }
                        />
                    ))}

                {/* Fallback */}
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </Router>
    );
}

export default App;
